import { useState } from 'react';
import { NavLink } from 'react-router-dom';
import { navLinks } from '../data/content';

function Navbar() {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <header className={`navbar ${isOpen ? 'navbar-open' : ''}`}>
      <div className="navbar-brand">
        <img src="/assets/logo.svg" alt="Goal Path HR Solution" className="navbar-logo" />
        <span className="visually-hidden">Goal Path HR Solution</span>
      </div>
      <button className="navbar-toggle" onClick={() => setIsOpen(!isOpen)}>
        <span />
        <span />
        <span />
      </button>

      <nav className="navbar-menu">
        {navLinks.map((link) => (
          <NavLink
            key={link.to}
            to={link.to}
            className={({ isActive }) => (isActive ? 'nav-link active' : 'nav-link')}
            onClick={() => setIsOpen(false)}
          >
            {link.label}
          </NavLink>
        ))}
      </nav>
    </header>
  );
}

export default Navbar;
